import React from "react";
import Lottie from "lottie-react";
import butterflyAnimation from "../../../assets/home/Butterfly.json";
import butterflyAnimation2 from "../../../assets/home/Butterfly2.json";
import "./SunHome.css";

export const SunAnimations: React.FC = () => (
	<>
		<Lottie
			animationData={butterflyAnimation}
			loop
			style={{
				position: "absolute",
				width: "100%",
				height: "100%",
				bottom: "-33vh",
				left: "15vw",
				zIndex: 5,
			}}
			autoplay
		/>
		<Lottie
			animationData={butterflyAnimation2}
			loop
			style={{
				position: "absolute",
				width: "100%",
				height: "100%",
				bottom: "-23vh",
				right: "-5vw",
				zIndex: 5,
			}}
			autoplay
		/>
	</>
);
